import React, {useCallback, useEffect, useState, useMemo} from 'react'
import _ from 'lodash'
import {ReactComponent as Reload} from '../../../../assets/icons/renew.svg'
import {usePreviewArtworks} from '../../../../hooks/usePreviewArtworks'
import {useSelectedVariantContext} from '../../context/SelectedVariantContext'
import {isSubsetAttributes} from '../../context/SelectedVariantContext/helper'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import CampaignDesignLoading from '../../upload/tabs/campaign-design/CampaignDesignLoading'
import PreviewBackgroundImage from './PreviewBackgroundImage'
import { getMockup2DGeneratorInstance } from '../preview-live/mockup-2d/Mockup2DGenerator'

const PreviewArtworkContainer = () => {
    const {fetchPreviews, fetchPreview3D, percentage, pending} = usePreviewArtworks()
    const {
        state: {selectedAttribute, previewImages, reloadPreview, reloadBgPreview, useClientMockup, previewImages3D, has3DPreview, product, selectedPlacements, mappedAttributes},
        dispatch,
    } = useSelectedVariantContext()
    const {mockups} = product
    const mockupInfos = useMemo(() => {
        return _.get(selectedAttribute?.mockup, 'meta.mockup_infos', [])
    }, [selectedAttribute?.mockup])
    const [wPreview, setWPreview] = useState(200)
    const [hPreview, setHPreview] = useState(200)

    const [previewSrc, setPreviewSrc] = useState([])
    const [firstLoad, setFirstLoad] = useState(true)
    const [preview3DImages, setPreview3DImages] = useState({})

    const generateCurrentVariant = () => {
        return Object.keys(mappedAttributes).map(attr => {
            return mappedAttributes[attr].find(variant => variant.is_selected === true)?.value_text
        })
    }

    const loadPreviewImages = useCallback(() => {
        if (!selectedAttribute) return []

        setOnImgError(false)
        setFirstLoad(false)

        if (!useClientMockup) {
            // Fall back to server-fetched preview images
            const selectedAttr = selectedAttribute.attributes.map((attr) => {
                return {type: attr.type, value: attr.value_code}
            })

            const images = previewImages
                .find((preview) => isSubsetAttributes(preview.attributes, selectedAttr))?.images || []
            const timestampedImages = images.map((url) => `${url}?timestamp=${new Date().getTime()}`)
            setPreviewSrc(timestampedImages)
        }

    }, [previewImages, selectedAttribute])

    // const getInfoPreviewArtworkSlider = () => {
    //     let w = 0
    //     let h = 0
    //     if (document.querySelector('.PreviewArtworkContainer')) {
    //         w = window.innerWidth
    //         if (document.querySelector('#left-sidebar')) {
    //             w = window.innerWidth - document.querySelector('#left-sidebar').offsetWidth
    //         }
    //         if (document.querySelector('#right-sidebar')) {
    //             w = window.innerWidth - document.querySelector('#right-sidebar').offsetWidth
    //         }
    //         h = document.querySelector('.PreviewArtworkContainer').offsetHeight
    //     }
    //     setWPreview(w)
    //     setHPreview(h)
    // }

    useEffect(() => {
        loadPreviewImages()
    }, [loadPreviewImages])

    useEffect(() => {
        // getInfoPreviewArtworkSlider()
        fetchPreviews()
        //window.addEventListener('resize', getInfoPreviewArtworkSlider)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [onImgError, setOnImgError] = useState(false)

    const loading = reloadPreview || (pending && !onImgError)

    const handleReload = () => {
        if (useClientMockup) {
            // If using 3D previews, just reload the images
            loadPreviewImages()
        } else {
            // Otherwise, fetch from server
            fetchPreviews()
        }
    }

    useEffect(() => {
        if (useClientMockup) {
            if (preview3DImages[selectedAttribute.key]) {
                return setPreviewSrc(preview3DImages[selectedAttribute.key])
            }

            const mockup2DGenerator = getMockup2DGeneratorInstance()
            mockup2DGenerator.clearCache()
            mockup2DGenerator.loadMockupInfos(selectedAttribute?.mockup.meta.mockup_infos)

            const artwork = fetchPreview3D(true, 1)
            if (!artwork) return

            const colorAttr = selectedAttribute?.attributes?.find((a) => a.type === 'color')

            mockup2DGenerator.render(artwork, colorAttr?.color_code || '#ffffff').then(async (mockups) => {
                setPreview3DImages({ ...preview3DImages, [selectedAttribute.key]: mockups })
                setPreviewSrc(mockups)
            })
        }
    }, [useClientMockup, selectedAttribute])

    return (
        <div className={`PreviewArtworkContainer d-flex`}>
            {percentage !== 0 && loading && (
                <div className="LoadingContainer d-flex align-items-center justify-content-center"
                     style={{height: "100%", width: "100%"}}>
                    <CampaignDesignLoading
                        percentage={percentage}
                        text="Your mockup is generating, please wait..."
                    />
                </div>
            )}
            <div className={loading ? 'd-none' : 'd-block'}>
                {onImgError ? (
                    <div className="PreviewArtworkErrorWrapper text-center">
                        <div className="PreviewArtworkError">
                            <div>
                                <p className="text-danger mb-0">Something went wrong, please try again.</p>
                                <Reload width={20} height={20} onClick={loadPreviewImages} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="PreviewArtworkWrap">
                        <h2>Final mockups</h2>
                        <h5>{generateCurrentVariant().join(', ')}</h5>
                        <div className="PreviewArtworkGrid d-flex">
                            {
                                previewSrc.map((src, index) => {
                                    return selectedPlacements.includes(mockupInfos[index]?.name) ? <div key={index} className='Image'>
                                        {/*{!firstLoad && (*/}
                                        {/*    <div className='ImageFirstLoading text-center'>*/}
                                        {/*        <Spinner style={{color: '#007bff'}} />*/}
                                        {/*    </div>*/}
                                        {/*)}*/}
                                        <PreviewBackgroundImage
                                            index={index}
                                            imageProp={src}
                                            reloadBgPreview={reloadBgPreview}
                                            wPreview={wPreview}
                                            hPreview={hPreview}
                                        />
                                        <label>{mockupInfos[index]?.name || ''}</label>
                                    </div> : null
                                })
                            }
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PreviewArtworkContainer